import {h, Fragment} from "preact"
export default function ProductBadge({product}) {
    let badge = null;
    const tags = product.tags1 || [];
  
    // Parse numbers safely
    const price = parseFloat(product.price || 0);
    const listPrice = parseFloat(product.listPrice || 0);
  
    for (const tag of tags) {
      const tagLower = tag.toLowerCase();
  
      // Coming Soon / Out of Stock / Members Only
      if (['_coming soon', 'out of stock', '_members only'].includes(tagLower)) {
        const text = tag.startsWith('_') ? tag.substring(1) : tag;
        badge = (
          <span className="absolute inline-block items-center text-[0.6875rem] leading-[0.45] uppercase top-12 left-12 z-10 pt-[7px] pb-[6px] px-[5px] bg-black text-white border-transparent">
            {text}
          </span>
        );
        break;
      }
  
      // Custom Badge
      if (tagLower.includes('custombadge')) {
        let text = tag.replace(/custombadge_/i, '');
        if (text.startsWith('_')) {
          text = text.substring(1);
        }
        badge = (
          <span className="absolute inline-block items-center text-[0.6875rem] leading-[0.45] uppercase top-12 left-12 z-10 pt-[7px] pb-[6px] px-[5px] bg-white text-black">
            {text}
          </span>
        );
        break;
      }
    }
  
    // Sale Badge (only if no other badge was applied)
    if (!badge && listPrice > price) {
      const sale = ((price + 0.01) / (listPrice + 0.01)) * 100;
      const saleRounded = Math.round(100 - sale);
      if (saleRounded > 0) {
        const saleString = `-${saleRounded}%`;
        badge = (
          <span className="absolute inline-block items-center text-[0.6875rem] leading-[0.45] uppercase top-12 left-12 z-10 pt-[7px] pb-[6px] px-[5px] bg-black text-white border-transparent">
            {saleString}
          </span>
        );
      }
    }
  
    return badge;
  }